import { css } from 'aphrodite';
import moment from 'moment';
import * as React from 'react';
import { CancelIconFill } from '../../../../web/components/svgs/icons/CancelIconFill';
import { SuccessCheckIcon } from '../../../../web/components/svgs/icons/SuccessCheckIcon';
import { SuccessUncheckIcon } from '../../../../web/components/svgs/icons/SuccessUncheckIcon';
import { styleSheet } from './styles';

interface IProps {
	met?: boolean;
}

export const UserMilestone: React.FC<IProps> = props => {
	const { met } = props;

	return met ? (
		<div>
			<SuccessCheckIcon fillColor='#89C947' />
		</div>
	) : (
		<div>
			<SuccessUncheckIcon fillColor='#EBEBEB' ringColor='#F6F6F6' />
		</div>
	);
};

export const SocialConnectedUserMilestone: React.FC<
	IProps & {
		disconnected?: boolean;
	}
> = props => {
	const { disconnected } = props;
	if (disconnected) {
		return (
			<div>
				<CancelIconFill />
			</div>
		);
	}

	return <UserMilestone {...props} />;
};

export const EmailConnectedUserMilestone: React.FC<
	IProps & {
		disconnectedDate?: string;
	}
> = props => {
	const { disconnectedDate } = props;
	const disconnectedMDY = disconnectedDate ? moment(disconnectedDate).format('MM/DD/YY') : undefined;
	const disconnectedTime = disconnectedDate ? moment(disconnectedDate).format('h:mm A') : undefined;

	if (disconnectedDate) {
		return (
			<div>
				<CancelIconFill />
				<div className={css(styleSheet.disconnected)}>{disconnectedMDY}</div>
				<div className={css(styleSheet.disconnected)}>{disconnectedTime}</div>
			</div>
		);
	}
	return <UserMilestone {...props} />;
};
